import { SelectOption } from '../../../../../../components/CiscoUi';

export const convertScriptsToOptions = (
  scripts: HardwareScript[],
): SelectOption<string>[] =>
  scripts.map((item) => ({ name: item.name, value: item.uid }));
